export const SESSION_META_KEYS = new Set(['projectType']);

export const emptyConsumerSession = {
  projectType: null,
  projectName: '',
  projectPassword: '',
};

export const pickCredentials = (source) => {
  if (!source || typeof source !== 'object') {
    return null;
  }

  const credentials = Object.fromEntries(
    Object.entries(source).filter(([key, value]) => !SESSION_META_KEYS.has(key) && value != null && value !== ''),
  );

  if (!credentials.projectName || !credentials.projectPassword) {
    return null;
  }

  return credentials;
};

export const buildConsumerSession = (payload = {}) => {
  const credentials = Object.fromEntries(Object.entries(payload).filter(([key]) => !SESSION_META_KEYS.has(key)));

  return {
    projectType: payload.projectType ?? null,
    projectName: '',
    projectPassword: '',
    ...credentials,
  };
};
